module.exports = __webpack_public_path__ + "media/hallBgm.6be7d44d.mp3";